import React, { Component } from 'react'
import { OrdinalFrame } from 'semiotic'
import { withStyles } from 'material-ui/styles'
import * as moment from 'moment'

const styles = theme => ({
  divChartBurnDown: {
    position: 'absolute',
    marginLeft: theme.spacing.unit * 5
  },
  divAlign: {
    marginLeft: -theme.spacing.unit * 6,
    width: window.innerWidth
  }
})

const generate = () => {
  var dates = []
  var a = moment()
    .week(1)
    .day(0)
  for (var i = 0; i < 52; i++) {
    dates.push(moment(new Date(a.add(1, 'weeks'))).unix() * 1000)
  }
  dates.push(moment().unix() * 1000)
  return dates
}

const axis = {
  orient: 'bottom',
  tickFormat: d => (
    <text
      key={`tick-${d}`}
      style={{ fill: '#cecece', textAnchor: 'end', fontSize: 9 }}
      y={-2}
      x={-window.innerWidth / 100}
    >
      {moment(new Date(d)).day() === 0 &&
        (moment(new Date(d)).date() < 8
          ? moment(new Date(d)).format('M.D')
          : moment(new Date(d)).format('D'))}
    </text>
  ),
  //ticks: 10,
  tickValues: generate(),
  baseline: false,
  tickLineGenerator: ({ xy }) => (
    <path
      key={`tickLine-${xy.value}`}
      style={{
        stroke:
          moment(new Date(xy.value)).format('l') === moment().format('l')
            ? 'rgba(255,192,203,.3)'
            : '#F0F0F0 '
      }}
      d={`M${xy.x1 - window.innerWidth / 45},${xy.y1 - 5}L${xy.x2 -
        window.innerWidth / 45},${xy.y2 - 5}L${xy.x2 -
        window.innerWidth / 45},${xy.y1 + 5}L${xy.x1 -
        window.innerWidth / 45},${xy.y1 + 5}Z`}
    />
  )
}

@withStyles(styles)
export default class AlchemyProjectRoadmap extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  render() {
    const { classes } = this.props
    var tmp = this.props.data.filter(
      e => e.dateComplete !== '' && e.tags === 'alchemy'
    )

    // sort
    tmp.sort(function(a, b) {
      return new Date(a.date) - new Date(b.date)
    })

    return (
      <div className={classes.divAlign}>
        <div
          id="daily_sleep_chart_view"
          style={{
            position: 'relative',
            textAlign: 'center',
            width: this.props.width,
            height: this.props.height
          }}
        >
          <div className={classes.divChartBurnDown}>
            <OrdinalFrame
              size={[this.props.width / 1.1, this.props.height]}
              data={tmp}
              rAccessor={d => [new Date(d.date), new Date(d.dateComplete)]}
              oAccessor={'projectName'}
              type={{
                type: 'timeline'
              }}
              rExtent={[undefined, undefined]}
              projection="horizontal"
              oPadding={this.props.width / 35}
              margin={{
                left: this.props.width / 10,
                top: this.props.height / 60,
                right: this.props.width / 10,
                bottom: this.props.height / 9.6
              }}
              style={d => ({
                fill:
                  d.status === 'closed'
                    ? '	rgba(152,251,152,.5)'
                    : d.status === 'open'
                      ? 'rgba(255,228,181,.5)'
                      : 'rgba(0,0,0,0)',
                stroke: d.status === 'backlog' ? 'lightblue' : 'rgba(0,0,0,0)'
              })}
              oLabel={d => (
                <text
                  key={`label-${d}`}
                  fill="#cecece"
                  textAnchor="middle"
                  fontSize={10}
                  x={0}
                >
                  {d}
                </text>
              )}
              hoverAnnotation={false}
              axis={axis}
            />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ChartTypes/AlchemyProjectRoadmap.js